import styled from '@emotion/styled'
import sv from "../styles/marketing";

const AuthButton = styled(`div`)`
  ${sv.buttonBase};
  flex: ${props => props.cancel ? 1 : 2};
  background: ${props => props.cancel ? sv.colors.light : sv.colors.body};
  color: ${props => props.cancel ? sv.colors.body : sv.colors.light};
  padding: 0 16px;
  opacity: ${props => props.disabled ? .2 : 1};
  margin-right: ${props => props.cancel ? '16px' : 0};
  border: ${props => props.cancel ? '1px solid ' + sv.colors.body : ''};
  text-align: center;
  max-width: ${props => props.maxWidth ? props.maxWidth : '400px'};   
  ${props => props.disabled ? 'cursor: default!important;' : ''};
  
  /* prevent overflow if longText is passed*/
  @media(max-width: 500px) {
    /* px is fallback if vw isn't supported */
    ${props => props.longText ? 'font-size: 11px; font-size: 3vw;' : ''}
  }
`;

export default AuthButton;